<template>
  <svg :class="svgClass" aria-hidden="true">
    <title>{{title}}</title>
    <use :xlink:href="iconName"/>
  </svg>
</template>

<script>
export default {
  name: 'SvgIcon',
  props: {
    iconClass: {
      type: String,
      required: true
    },
    className: {
      type: String,
      default: ''
    },
    // 是否填充（非所有都有）
    fill: {
      type: Boolean,
      default: false
    },
    title: {
      type: [String, Number]
    }
  },
  computed: {
    iconName () {
      let name = (this.fill) ? `#icon-${this.iconClass}-fill` : `#icon-${this.iconClass}`
      return name
    },
    svgClass () {
      if (this.className) {
        return 'svg-icon ' + this.className
      } else {
        return 'svg-icon'
      }
    }
  }
}
</script>

<style scoped>
.svg-icon {
  width: 16px;
  height: 16px;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}

.svg-external-icon {
  background-color: currentColor;
  mask-size: cover!important;
  display: inline-block;
}
</style>
